import React, { useState, useContext } from "react";
import {
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import WhatsAppScan from "./WhatsAppScan";

export default function WhatsAppStatusChip({ session, status, propertyId, onSuccess }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    if (status?.code === 'connected') return; // Prevent opening if already connected
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  return (
    <>
      <Chip
        label={`${status?.label}${session?.connectedPhoneNumber ? `: ${session?.connectedPhoneNumber}` : ``}`}
        style={{
          backgroundColor: `${status?.color ?? "#6b7280"}1A`,
          color: status?.color ?? "#6b7280",
          border: `1px solid ${(status?.color ?? "#6b7280")}33`,
          fontWeight: 600,
          height: 24,
          cursor: "pointer",
        }}
        size="small"
        onClick={handleOpen}
      />

      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>
          Scan WhatsApp QR
          <IconButton
            aria-label="close"
            onClick={handleClose}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <WhatsAppScan 
            propertyId={propertyId} 
            status={status}
            qrCode={session?.qrCode}
            onSuccess={onSuccess} 
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
